module.exports = __webpack_public_path__ + "static/media/membership-monthly-md.f1ecdb40.png";